import { z } from "zod";
export const CharacterDifficultySchema = z.object({
    label: z.string().optional(),
    name: z.string(),
    value: z.number().positive().min(1),
    maxValue: z.number().positive().max(4),
});
//# sourceMappingURL=index.js.map